module.exports = __webpack_public_path__ + "static/img/panghu.9be98b5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/panghu.png
// module id = jgU6
// module chunks = 37